import { render, staticRenderFns } from "./AppHeaderMain.vue?vue&type=template&id=180861be&scoped=true&"
import script from "./AppHeaderMain.vue?vue&type=script&lang=ts&"
export * from "./AppHeaderMain.vue?vue&type=script&lang=ts&"
import style0 from "./AppHeaderMain.vue?vue&type=style&index=0&id=180861be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180861be",
  null
  
)

/* custom blocks */
import block0 from "./AppHeaderMain.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports